var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10565",
    "data-name": "Group 10565",
    transform: "translate(-1065 -1496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17830",
    "data-name": "Rectangle 17830",
    width: 40,
    height: 40,
    transform: "translate(1065 1496)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-travel-agency",
    "data-name": "Icon map-travel-agency",
    d: "M35.826,10.7H26.448V7.588c0-2.228-1.439-4.708-3.664-4.708h-7.5c-2.228,0-3.688,2.48-3.688,4.708V10.7H3A1.568,1.568,0,0,0,1.44,12.258V34.922A1.568,1.568,0,0,0,3,36.485H35.826a1.568,1.568,0,0,0,1.563-1.563V12.258A1.568,1.568,0,0,0,35.826,10.7ZM23.322,34.14h-8.6v-.834c0-.018.479-.041.708-.069a2.471,2.471,0,0,0,.595-.138,1.506,1.506,0,0,0,.741-.474,1.621,1.621,0,0,0,.3-.817V23.814a1.7,1.7,0,0,0-.341-.845,2.006,2.006,0,0,0-.61-.584,1.827,1.827,0,0,0-.615-.316c-.334-.1-.779-.166-.779-.193v-1l6.389-.357-.137.206V31.63a1.675,1.675,0,0,0,.385.817,1.5,1.5,0,0,0,.68.5,4.561,4.561,0,0,0,.6.22c.22.064.681.109.681.138v.834ZM15.991,15.571a2.345,2.345,0,0,1,.8-1.786,2.837,2.837,0,0,1,3.825,0,2.356,2.356,0,0,1,.8,1.786,2.325,2.325,0,0,1-.8,1.779,2.849,2.849,0,0,1-3.819,0A2.324,2.324,0,0,1,15.991,15.571ZM24.1,10.7H13.944V7.588c0-.834.844-2.363,1.678-2.363h6.293c.832,0,2.189,1.529,2.189,2.363Z",
    transform: "translate(1065.585 1496.317)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravel);
export default __webpack_public_path__ + "static/media/ic_travel.dfd4d0d76ccb73dab8bcb031dac830e5.svg";
export { ForwardRef as ReactComponent };